import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LanguagePickerComponent } from './language-picker.component';

const routes: Routes = [{ path: '', component: LanguagePickerComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LanguagePickerRoutingModule { }
